import { Modal, Button, Form, InputGroup } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import axios from "axios";

const AssignHospitalModal = ({ showModal, hideModal, specialtyId, assignedHospitals, onSuccess }) => {
    const [allHospitals, setAllHospitals] = useState([]);
    const [filteredHospitals, setFilteredHospitals] = useState([]);
    const [selectedHospitals, setSelectedHospitals] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        const fetchHospitals = async () => {
            try {
                const { data } = await axios.get(`/hospitals`);
                const unassignedHospitals = data.filter(
                    (hospital) =>
                        !assignedHospitals.some(
                            (assigned) => assigned.hospital_id === hospital.hospital_id
                )
                );
                setAllHospitals(unassignedHospitals);
                setFilteredHospitals(unassignedHospitals); // Initially, all unassigned hospitals are shown
            } catch (error) {
                console.error("Failed to fetch hospitals:", error);
            }
        };
  
        if (showModal) {
            fetchHospitals();
        }
    }, [showModal, assignedHospitals]);

    const handleSearchChange = (e) => {
        const term = e.target.value.toLowerCase();
        setSearchTerm(term);
        setFilteredHospitals(
            allHospitals.filter((hospital) =>
                hospital.name.toLowerCase().includes(term)
            )
        );
    };

    const toggleHospitalSelection = (hospital) => {
        setSelectedHospitals((prevSelected) => {
            if (prevSelected.some((item) => item.hospital_id === hospital.hospital_id)) {
                return prevSelected.filter((item) => item.hospital_id !== hospital.hospital_id);
            } else {
                return [...prevSelected, hospital];
            }
        });
    };

    const handleAssignHospitals = async () => {
        try {
            const hospitalIds = selectedHospitals.map((hospital) => hospital.hospital_id);
            await axios.post(`/assign_hospital`, { specialtyId, hospitalIds });
            onSuccess();
            hideModal();
        } catch (error) {
            console.error("Failed to assign hospitals:", error);
            alert("Error assigning hospitals.");
        }
    };

    return (
        <Modal style={{marginTop: "60px"}} show={showModal} onHide={hideModal} size="lg" centered backdrop={false}>
            <Modal.Header closeButton>
                <Modal.Title>Assign Hospitals</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <InputGroup className="mb-3">
                    <Form.Control
                        type="text"
                        placeholder="Search hospitals"
                        value={searchTerm}
                        onChange={handleSearchChange}
                    />
                </InputGroup>
                <Form>
                    {filteredHospitals.length === 0 && <p>No hospitals found.</p>}
                    {filteredHospitals.map((hospital) => (
                        <Form.Check
                            key={hospital.hospital_id}
                            type="checkbox"
                            label={hospital.name}
                            checked={selectedHospitals.some(
                                (item) => item.hospital_id === hospital.hospital_id
                            )}
                            onChange={() => toggleHospitalSelection(hospital)}
                        />
                    ))}
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={hideModal}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleAssignHospitals}>
                    Assign
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AssignHospitalModal;
